import BaseObject from "../../../base/base_object";
import {PRIORITY_LEVEL} from "../../overlay_manager/overlay_manager_levels";
import {CASHIER_ACTIONS} from "../../../components/external_links/external_links_consts";
import Device from "../../../utils/device/device";
import _ from "../../../utils/underscore";
import TempAccountComponent from "../../../components/temp_account/temp_account_component";
import {SYSTEM_EVENTS} from "../../../events/events";
import Event from '../../../utils/event';
import {TEMP_ACCOUNT_STATUS} from '../regulation_const';
import ServiceFactory from "../../service_factory";
import DOM from "../../../utils/dom"

export default class TempAccountMessageRegulationHelper extends BaseObject {

    _serviceFactory: ServiceFactory = null;

    init(params) {
        super.init(params);
        params = params || {};
        if(!params.serviceFactory) {
            this.throwArgumentExpected('21', 'init', 'serviceFactory');
        }

        this._serviceFactory = params.serviceFactory;
    }

    _getDefaultAccountStatus() {
        const daysLeft = this._serviceFactory.userService().getAccountData().DaysToUploadDocument;
        if (_.isNullOrUndefined(daysLeft) || 0 > daysLeft)
            return {
                status: TEMP_ACCOUNT_STATUS.APPROVED
            };
        else {
            return {
                status: TEMP_ACCOUNT_STATUS.DOCUMENTS_NOT_RECEIVED,
                daysLeft: daysLeft
            };
        }
    }

    _getMessageOptionsByStatus(status: string, el: HTMLElement, footerEl: HTMLElement, msgParams) {
        const messageOptions = {
			text: el,
			footerText: footerEl,
            priority: PRIORITY_LEVEL.TEMP_ACCOUNT,
            closeButton: true,
            customCSSClassList: ['mdp-mobile-full-size'],
			title: this._serviceFactory.languageService().translation(msgParams.titleKey),
			hideDaysLeft: msgParams.hideDaysLeft ? msgParams.hideDaysLeft : false,
        }

        // PENDING_VERIFICATION
        const pendingVerificationOptions = {
            hasDefaultButton: true,
        };

        // DOCUMENTS_NOT_RECEIVED
        const documentVerifyOptions = {
			hasDefaultButton: false,
            buttons: [{
                name: this._serviceFactory.languageService().translation(msgParams.btnNameKey),
                callback: () => {
                    this._serviceFactory.openLinkService().openLink({
                            source: this._serviceFactory.regulationService().getTempAccountGnwpSource(),
                            options: {sessionType: Device.isMobile() ? CASHIER_ACTIONS.MOBILE_VERIFY_ID : CASHIER_ACTIONS.VERIFY_ID}
                        }
                    );
                    Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {
                        category: 'temp_account_message',
                        action: 'upload_docs'
                    });
                },
                isClosable: true
            }],
            btnCloseCallback: () => {
                Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {
                    category: 'temp_account_message',
                    action: 'close'
                });
            }
        };

        if (!_.isNullOrUndefined(msgParams.closeFunc)) {
            documentVerifyOptions.btnCloseCallback = msgParams.closeFunc;
        }

        let statusOptions = {};
        switch (status) {
            case TEMP_ACCOUNT_STATUS.PENDING_VERIFICATION:
                statusOptions = pendingVerificationOptions;
                break;
            case TEMP_ACCOUNT_STATUS.DOCUMENTS_NOT_RECEIVED:
                statusOptions = documentVerifyOptions;
                break;
        }

        return Object.assign({}, messageOptions, statusOptions);
    }


    showTempAccountMessage(params) {
        const languageService = this._serviceFactory.languageService();
        const oauthService = this._serviceFactory.oAuth2Service();

        if (!oauthService.isAuthorized()) {
            return;
        }

        let tempAccountParams;
        if (!_.isNullOrUndefined(params.paramsFunc)) {
            tempAccountParams = params.paramsFunc.call();
        } else {
            tempAccountParams = Object.assign({}, this._getDefaultAccountStatus(), params);
        }
        if (tempAccountParams && tempAccountParams.status === TEMP_ACCOUNT_STATUS.APPROVED) {
            return;
        }

        const component = TempAccountComponent.create({
                daysLeft: tempAccountParams.daysLeft,
                status: tempAccountParams.status,
				messageText: languageService.translation(tempAccountParams.messageKey),
				hideDaysLeft: tempAccountParams.hideDaysLeft ? tempAccountParams.hideDaysLeft : false
            }).start();

        let footerComponent = null;
        if (tempAccountParams.footerMessageKey) {
            footerComponent = DOM.createElement("div",  languageService.translation(tempAccountParams.footerMessageKey) );
        }

        this._serviceFactory.messageManagerService().openMessage(
            this._getMessageOptionsByStatus(tempAccountParams.status,
                component.getEl(),
                footerComponent,
                tempAccountParams
            )
        );

        this._serviceFactory
            .structuredLoggingService()
            .getLogger({
                eventName: 'TEMP_ACCOUNT_MESSAGE_SHOWN',
            })
            .info();
    }
}
